export const getUnique = (arr, comp) => {
  const unique = arr
    .map(e => e[comp])
    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)
    // eliminate the dead keys & store unique objects
    .filter(e => arr[e])
    .map(e => arr[e])
  return unique
}

export const formatBytes = (a, b) => {
  if (0 == a) return '0 Bytes'
  var c = 1024,
    d = b || 2,
    e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    f = Math.floor(Math.log(a) / Math.log(c))
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}

export const limpiarValorMondeda = valor =>
  valor
    .replace(/\s+/g, '')
    .replace(/\$+/g, '')
    .replace(/\.+/g, '')
    .replace(/,+/g, '')

export const convertirAMoneda = value =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP'
  })
    .format(parseInt(value, 10) === 'NaN' ? 0 : value)
    .replace(/\D00$/, '')

export const validarTeclascomunes = key =>
  key !== 'ArrowRight' &&
  key !== 'ArrowLeft' &&
  key !== 'Backspace' &&
  key !== 'Delete' &&
  key !== 'Tab'

export const validarSoloNumeros = valor => {
  var reg = /^\d+$/;
  return reg.test(valor)
}

export const obtenerNombreArchivoSinExtension = fileName => fileName.split('.').slice(0, -1).join('.')
